import { faPlayCircle, faPauseCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import { PLAY_BUTTON_COMPONENT } from '../../../../brands/default/content/components/deal';

const PlayButton = ({ isPlaying, togglePlayback }) => {
  return (
    <button
      aria-label={
        isPlaying
          ? PLAY_BUTTON_COMPONENT.pauseVideo
          : PLAY_BUTTON_COMPONENT.playVideo
      }
      className="deal-video__button-listing"
      onClick={(event) => {
        event.stopPropagation();
        togglePlayback();
      }}
      type="button"
    >
      <FontAwesomeIcon
        icon={isPlaying ? faPauseCircle : faPlayCircle}
        style={{
          height: 50,
          width: 50,
        }}
      />
    </button>
  );
};

PlayButton.propTypes = {
  isPlaying: PropTypes.bool,
  togglePlayback: PropTypes.func,
};

PlayButton.defaultProps = {
  isPlaying: false,
  togglePlayback: () => false,
};

export default PlayButton;
